export default "__VITE_ASSET__DPrH7Bvl__"